import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /app/assessments/:templateId/*. Renders <Outlet /> so child
 * routes (`/` index = detail, `/assign`, `/bulk-assign`) can mount here.
 */
export const Route = createFileRoute('/app/assessments/$templateId')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: ClinicalAssessmentLayout,
  staticData: { crumb: 'Template' },
});

function ClinicalAssessmentLayout() {
  return <Outlet />;
}
